import { TextColor } from "../../../../base/styles";
import clsx from "clsx";

export const SelectTextColor = ({ title, value, className, onChange }:{
    title: string,
    value?: TextColor,
    className?: string,
    onChange: (value?: TextColor) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as TextColor;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={TextColor.Primary}>Primary</option>
                <option value={TextColor.Secondary}>Secondary</option>
                <option value={TextColor.Success}>Success</option>
                <option value={TextColor.Danger}>Danger</option>
                <option value={TextColor.Warning}>Warning</option>
                <option value={TextColor.Info}>Info</option>
                <option value={TextColor.Light}>Light</option>
                <option value={TextColor.Dark}>Dark</option>
                <option value={TextColor.Body}>Body</option>
                <option value={TextColor.White}>White</option>
                <option value={TextColor.Gray100}>Gray - 100</option>
                <option value={TextColor.Gray200}>Gray - 200</option>
                <option value={TextColor.Gray300}>Gray - 300</option>
                <option value={TextColor.Gray400}>Gray - 400</option>
                <option value={TextColor.Gray500}>Gray - 500</option>
                <option value={TextColor.Gray600}>Gray - 600</option>
                <option value={TextColor.Gray700}>Gray - 700</option>
                <option value={TextColor.Gray800}>Gray - 800</option>
                <option value={TextColor.Gray900}>Gray - 900</option>

                <option value={TextColor.LightPrimary}>Light Primary</option>
                <option value={TextColor.LightSuccess}>Light Success</option>
                <option value={TextColor.LightInfo}>Light Info</option>
                <option value={TextColor.LightWarning}>Light Warning</option>
                <option value={TextColor.LightDanger}>Light Danger</option>
                <option value={TextColor.LightDark}>Light Dark</option>

                <option value={TextColor.InversePrimary}>Inverse Primary</option>
                <option value={TextColor.InverseSecondary}>Inverse Secondary</option>
                <option value={TextColor.InverseSuccess}>Inverse Success</option>
                <option value={TextColor.InverseInfo}>Inverse Info</option>
                <option value={TextColor.InverseLight}>Inverse Light</option>
                <option value={TextColor.InverseWarning}>Inverse Warning</option>
                <option value={TextColor.InverseDanger}>Inverse Danger</option>
                <option value={TextColor.InverseDark}>Inverse Dark</option>
                <option value={TextColor.InverseWhite}>Inverse White</option>
            </select>
        </div>
    )
}